import React from 'react';

import { IConversation, MessageRole, StreamStatus } from '../../../api/types';
import { AssistantChatMessageView } from '../Message/AssistantChatMessageView';
import { DefaultChatMessageView } from '../Message/DefaultChatMessageView';
import { FailedChatMessageView } from '../Message/FailedChatMessageView';
import { UserChatMessageView } from '../Message/UserChatMessageView';

export type MessagesRendererProps = {
    conversation?: IConversation | null;
};

const MessagesRendererComponent: React.FC<MessagesRendererProps> = ({ conversation }) => {
    if (!conversation) {
        return null;
    }

    if (conversation?.messages?.length === 0) {
        return <DefaultChatMessageView />;
    }

    return (
        <>
            {conversation.messages.map((message) => {
                // If the message is failed, show the failed message view
                if (message.status === StreamStatus.FAILED) {
                    return (
                        <FailedChatMessageView key={message.message_id} message={message} conversation={conversation} />
                    );
                }

                return message.role === MessageRole.ASSISTANT ? (
                    <AssistantChatMessageView key={message.message_id} message={message} conversation={conversation} />
                ) : (
                    <UserChatMessageView key={message.message_id} message={message} />
                );
            })}
        </>
    );
};

export const MessagesRenderer = React.memo(MessagesRendererComponent);
